export interface DocumentDownloadable {
    title: string;
    de: string;
    fr: string;
    it: string;
}

export const CONTACT_DOCUMENT_ABLAUF_PV_NEW_PREMIUM_DEPOT: DocumentDownloadable = {
    title: 'requiredDocumentTitle.ablaufPv',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-eroeffnung-praemiendepot.pdf',
    fr: 'https://www.pax.ch/fr/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-eroeffnung-praemiendepot.pdf',
    it: 'https://www.pax.ch/it/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-eroeffnung-praemiendepot.pdf',
};

export const CONTACT_DOCUMENT_BEGUENSTIGUNG_3A: DocumentDownloadable = {
    title: 'requiredDocumentTitle.beguenstigung.3a',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-beguenstigungserklaerung-saeule-3a.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-clause-beneficiaire-pilier-3a.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-clausola-beneficiara-previdenza-vincolata-pilastro-3a.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_ERWERBSUNFAEHIGKEIT_ANTRAG: DocumentDownloadable = {
    title: 'policyDetail.changeDisability.requiredDocument.antrag',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-antrag-auf-leistung-infolge-erwerbsunfaehigkeit.pdf?sc_lang=de&hash=B1EA217DF1210FF9B9237D33B43A2939',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-prestations-incapacite-gain.pdf?&sc_lang=fr&hash=CCDA5A2D2CA77A7D75BEB81E5E424465',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-domanda-prestazioni-incacacita-guadagno.pdf?&sc_lang=it&hash=A182A894843A5599EF6094F42FCA997A',
};

export const CONTACT_DOCUMENT_ERWERBSUNFAEHIGKEIT_AUSZAHLUNG: DocumentDownloadable = {
    title: 'policyDetail.changeDisability.requiredDocument.auszahlung',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-angaben-zur-auszahlung.pdf?sc_lang=de&hash=7331E28E129B56A972D3F610A48A6480',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-information-paiement.pdf?&sc_lang=fr&hash=5C9E93526FAE9A42296D719D584B434E',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-informazioni-pagamento.pdf?&sc_lang=it&hash=EDB0A42772C92178E0BC9D8BE215991B',
};

export const CONTACT_DOCUMENT_ERWERBSUNFAEHIGKEIT_AERZTLICHERERSTBERICHT: DocumentDownloadable = {
    title: 'policyDetail.changeDisability.requiredDocument.aerztlicherErstbericht',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-erstbericht-arzt-arbeitsunfaehigkeit.pdf?sc_lang=de&hash=7331E28E129B56A972D3F610A48A6480',
    fr: 'https://www.pax.ch/fr/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-erstbericht-arzt-arbeitsunfaehigkeit.pdf?&sc_lang=fr&hash=5C9E93526FAE9A42296D719D584B434E',
    it: 'https://www.pax.ch/it/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-erstbericht-arzt-arbeitsunfaehigkeit.pdf?&sc_lang=it&hash=EDB0A42772C92178E0BC9D8BE215991B',
};

export const CONTACT_DOCUMENT_FONDSSWITCH: DocumentDownloadable = {
    title: 'policyDetail.changeFunds.requiredDocument.fondsswitch',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-switch.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-ordre-switch.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-switch.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_FONDSVORAUSZAHLUNG_FATCA_AIA: DocumentDownloadable = {
    title: 'requiredDocumentTitle.fondsvorauszahlung.fatcaAia',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-technisches-formular-fatca-aia-erklaerung.pdf',
    fr: 'https://www.pax.ch/fr/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-declaration-fatca-et-ear.pdf',
    it: 'https://www.pax.ch/it/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-modulo-fatca-e-sai.pdf',
};

export const CONTACT_DOCUMENT_VORSORGEART: DocumentDownloadable = {
    title: 'requiredDocumentTitle.vorsorgeart',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-aenderungsantrag-saeulenwechsel.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-aenderungsantrag-saeulenwechsel.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-aenderungsantrag-saeulenwechsel.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_ZAHLUNGSMETHODE_DIRECTDEBITBANK: DocumentDownloadable = {
    title: 'requiredDocumentTitle.zahlungsmethodeBank',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-belastungsermaechtigung-bank.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-autorisation-bancaire.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-autorizzazione-di-addebito-bancario.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_ZAHLUNGSMETHODE_DIRECTDEBITPOST: DocumentDownloadable = {
    title: 'requiredDocumentTitle.zahlungsmethodePost',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-belastungsermaechtigung-post.pdf',
    fr: 'https://www.pax.ch/fr/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-autorisation-post.pdf',
    it: 'https://www.pax.ch/it/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-autorizzazione-di-addebito-post.pdf',
};

export const CONTACT_DOCUMENT_BENEFICIAL_OWNER: DocumentDownloadable = {
    title: 'requiredDocumentTitle.beneficialOwner',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-feststellung-wirtschaftlich-berechtigter.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/prevoyance-privee-determination-ayant-droit-economique.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/formulare/previdenza-privata-accertamento-avente-economicamente-diritto.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_VNWECHSELPV: DocumentDownloadable = {
    title: 'requiredDocumentTitle.vnWechselPv',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-wechsel-versicherungsnehmer.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-wechsel-versicherungsnehmer.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-wechsel-versicherungsnehmer.pdf?sc_lang=it',
};

export const CONTACT_DOCUMENT_VOLLMACHTPV: DocumentDownloadable = {
    title: 'policyDetail.changeVollmacht.requiredDocument.vollmacht',
    de: 'https://www.pax.ch/de/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-vollmacht.pdf',
    fr: 'https://www.pax.ch/fr/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-vollmacht.pdf',
    it: 'https://www.pax.ch/it/-/media/pax/download-files/private-vorsorge/formulare/private-vorsorge-vollmacht.pdf',
};

// Fonds

export const PAX_FONDS_AKTIEN_SCHWEIZ: DocumentDownloadable = {
    title: 'Fondscode 1300: Pax (CH) Fonds Aktien Schweiz ALV T',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-schweiz-de.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-schweiz-de.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-schweiz-de.pdf?sc_lang=it',
};

export const PAX_FONDS_AKTIEN_EUROPA_EX_SCHWEIZ: DocumentDownloadable = {
    title: 'Fondscode 1302: Pax (CH) Fonds Aktien Europa ex CH ALV T',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-europa-ex-schweiz.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-europa-ex-schweiz.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/pax-am/pam-einzelfonds-aktien-europa-ex-schweiz.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_25: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio 25',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-25.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-25.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-25.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_50: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio 50',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-50.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-50.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-50.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_75: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio 75',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-75.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-75.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-75.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_100: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio 100',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-100.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-100.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-100.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_ZIELRENDITE: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio Target Return',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-target-return.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-target-return.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-target-return.pdf?sc_lang=it',
};

export const PAX_FONDS_PORTFOLIO_QUALITY_SELECT: DocumentDownloadable = {
    title: 'Pax (CH) Sustainable Portfolio Quality Select',
    de: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-quality-select.pdf?sc_lang=de',
    fr: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-quality-select.pdf?sc_lang=fr',
    it: 'https://www.pax.ch/-/media/pax/download-files/private-vorsorge/fonds-factsheets/pax-sustainable-portfolio-quality-select.pdf?sc_lang=it',
};
